import PopularRubbish from '../components/PopularRubbish';
import PropertyClearances from '../components/PropertyClearances';
import SingleItemRemoval from '../components/SingleItemRemoval';
import OtherServices from '../components/OtherServices';
import ServicesBottom from '../components/ServicesBottom';
import './ServicesPage.css';

const FEATURES = [
  {
    label: 'On Demand',
    tone: 'pink',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 15c2-1 4-4 5.5-7.5C12 4 14 3 16.5 3.5 19 4 20 6.5 19 9c-1 2.8-3.5 5-6 6.5L8 18l-1.5-3.5L5 15z"
          fill="currentColor"
        />
        <path d="M8 18l-2 3M10.5 16.5L9 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: 'Licensed',
    tone: 'green',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="4" width="16" height="16" rx="4" fill="currentColor" />
        <path
          d="M8.5 12.2l2.2 2.2 4.8-5"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Secure Pay',
    tone: 'blue',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="6" width="18" height="12" rx="2.5" fill="#38bdf8" />
        <rect x="3" y="9" width="18" height="3" fill="#0ea5e9" />
        <rect x="6" y="14" width="5" height="2" rx="1" fill="#fff" />
      </svg>
    ),
  },
  {
    label: '5-Star Rated',
    tone: 'yellow',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 3.5l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 15.8 7.2 18.4l.9-5.4-3.9-3.8 5.4-.8L12 3.5z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    label: 'Leeds Based',
    tone: 'red',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 21s6.5-5.4 6.5-10.2A6.5 6.5 0 0 0 5.5 10.8C5.5 15.6 12 21 12 21z"
          fill="currentColor"
        />
        <circle cx="12" cy="10.5" r="2.3" fill="#fff" />
      </svg>
    ),
  },
  {
    label: 'No hidden charges',
    tone: 'purple',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="2" />
        <path d="M16 16l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: '2-Person Service',
    tone: 'amber',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M8 13c-2.2 1-3.5 2.6-3.5 4.5V19h7v-1.5c0-1.9-1.3-3.5-3.5-4.5z"
          fill="currentColor"
        />
        <path
          d="M16 13c2.2 1 3.5 2.6 3.5 4.5V19h-5.2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <circle cx="8" cy="8.5" r="2.5" fill="currentColor" />
        <circle cx="16" cy="8.5" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  },
  {
    label: 'Collection from site',
    tone: 'brown',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 4.5h8.5A1.5 1.5 0 0 1 15 6v12a1.5 1.5 0 0 1-1.5 1.5H5V4.5z"
          fill="currentColor"
        />
        <path
          d="M15 9.5h4.5L17 7.2M19.5 9.5L17 11.8"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="11.5" cy="12" r="1" fill="#fff" />
      </svg>
    ),
  },
  {
    label: '95%+ Metal Recovery',
    tone: 'green',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M7 8.5A6.5 6.5 0 0 1 18.5 11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M16 8.2l2.5 2.8 2.4-2.6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 15.5A6.5 6.5 0 0 1 5.5 13"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8 15.8L5.5 13l-2.4 2.6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Full Audit Trail',
    tone: 'doc',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="6" y="3.5" width="12" height="17" rx="2" fill="#e5e7eb" />
        <rect x="6" y="3.5" width="12" height="5" rx="2" fill="#3b82f6" />
        <path d="M9 12h6M9 15h4" stroke="#6b7280" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M15 14l3 1.2-1.2 3.2-3-1.2L15 14z" fill="#ec4899" />
      </svg>
    ),
  },
];

export default function ServicesPage() {
  return (
    <>
      <section className="services-page-hero" aria-labelledby="services-page-heading">
        <div className="services-page-inner">
          <header className="services-page-header">
            <h1 id="services-page-heading">Our Scrap Removal Services</h1>
            <p>
              Professional, licensed scrap metal collection for homes, builders, and businesses
              across Leeds. Full audit trail from pickup to recycling for complete peace of mind.
            </p>
          </header>

          <ul className="services-feature-grid">
            {FEATURES.map((feature) => (
              <li key={feature.label} className="services-feature-card">
                <span className={`services-feature-icon tone-${feature.tone}`}>{feature.icon}</span>
                <span className="services-feature-label">{feature.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <PopularRubbish />
      <PropertyClearances />
      <SingleItemRemoval />
      <OtherServices />
      <ServicesBottom />
    </>
  );
}
